<script setup lang="ts">
import { useDisciplineStore } from '../model/store'
import { useLessonCreateStore } from '../model/lessons/create/store'
import { useLessonCreatePage } from '../model/lessons/lesson-create-page.hook'
import DisciplinePageLoader from './DisciplinePageLoader.vue'
import LessonCreateSingle from './lessons/LessonCreateSingle.vue'

defineOptions({
  name: 'LessonCreatePage',
})

const disciplineStore = useDisciplineStore()
const lessonCreateStore = useLessonCreateStore()

const { refIsLoading } = useLessonCreatePage()
</script>

<template>
  <DisciplinePageLoader :loading="refIsLoading" />
  <LessonCreateSingle
    v-if="disciplineStore.getDiscipline && lessonCreateStore.getSlots"
  />
</template>
